import { Paragraph, PrescriptionIcon } from '@quickmd-llc/design-system'
import type { MedicationStaffApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { MedicationDetailView } from './MedicationDetailView'

function RxIcon() {
  return (
    <div className='flex h-20 w-20 items-center justify-center rounded-full bg-neutral-20'>
      <PrescriptionIcon iconSize='xxl' className='text-text-dark' />
    </div>
  )
}

interface MedicationDetailPanelProps {
  selectedMedication: MedicationStaffApiOutContract | null
}

export function MedicationDetailPanel({ selectedMedication }: MedicationDetailPanelProps) {
  if (selectedMedication) {
    return <MedicationDetailView medication={selectedMedication} />
  }

  return (
    <div className='flex h-full flex-col items-center justify-center gap-sp-2 rounded-large border border-border-medium bg-white'>
      <RxIcon />
      <Paragraph size='md' className='text-text-light'>
        Select a medication to view details
      </Paragraph>
    </div>
  )
}
